import { useLocation, useRoutes } from 'react-router';
import HomePage from './pages/site/HomePage/HomePage';
import useMetrikaTracking from './analytics/useMetrikaTracking';

function App() {
  const location = useLocation();

  useMetrikaTracking(location);

  let routes = useRoutes([
    {
      path: '/',
      element: <HomePage />,
    },
  ]);

  return routes;
}

export default App;
